import { useState, useEffect } from 'react'
import { Check, Loader2 } from 'lucide-react'

/**
 * Componente animazione salvataggio
 * 
 * @param {boolean} saving - Se sta salvando
 * @param {boolean} saved - Se ha appena salvato
 * @param {Function} onSavedComplete - Callback quando animazione finisce
 */
export function SaveAnimation({ saving, saved, onSavedComplete }) {
  const [showCheck, setShowCheck] = useState(false)

  useEffect(() => {
    if (saved) {
      setShowCheck(true)
      const timer = setTimeout(() => {
        setShowCheck(false)
        onSavedComplete?.()
      }, 2000)
      return () => clearTimeout(timer)
    }
  }, [saved, onSavedComplete])

  if (!saving && !showCheck) return null

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
      <div
        className={`
          p-6 rounded-2xl shadow-2xl transition-all duration-300
          ${showCheck 
            ? 'bg-green-500 scale-100 opacity-100' 
            : 'bg-white dark:bg-gray-800 scale-95 opacity-90'
          }
        `}
      >
        {saving && !showCheck && (
          <Loader2 className="h-12 w-12 text-primary-600 animate-spin" />
        )}
        {showCheck && (
          <div className="animate-bounce-in">
            <Check className="h-12 w-12 text-white" strokeWidth={3} />
          </div>
        )}
      </div>
    </div>
  )
}

/**
 * Bottone con stato di salvataggio integrato
 */
export function SaveButton({ 
  onClick, 
  saving = false, 
  disabled = false,
  children = 'Salva',
  className = ''
}) {
  return (
    <button
      onClick={onClick}
      disabled={saving || disabled}
      className={`
        flex items-center justify-center gap-2 px-4 py-2 rounded-lg
        bg-primary-600 text-white font-medium
        hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed
        transition-all duration-200
        ${className}
      `}
    >
      {saving ? (
        <>
          <Loader2 className="h-4 w-4 animate-spin" />
          <span>Salvataggio...</span>
        </>
      ) : (
        children
      )}
    </button>
  )
}

export default SaveAnimation
